import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/** @module hooks/sortable */
import { i18n, hooks, urlParam, addUrlParam, request } from "../util";
import $ from "jquery";
import store from "../store";
import { message } from "react-aiot";
var WP_TABLE_LIST_SELECTOR = ".wp-list-table.media tbody, .wp-list-table.attachments tbody";
/**
 * Apply an order to attachments browser without reloading the collection.
 */

export function applyToAttachmentsBrowser(attachmentsBrowser, selected) {
  var orderby = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "rml";
  var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "ASC";
  var filter;

  if (attachmentsBrowser && (filter = attachmentsBrowser.toolbar.get("rml_folder").filters[selected.id])) {
    var props = attachmentsBrowser.collection.props,
        o = {
      silent: true
    };

    if (selected.contentCustomOrder === 1 || selected.forceCustomOrder) {
      filter.props.orderby = "rml";
      filter.props.order = "ASC";
      props.set({
        orderby: orderby,
        order: order
      }, o);
    } else {
      delete filter.props.orderby;
      delete filter.props.order;
      props.set({
        orderby: "date",
        order: "DESC"
      }, o);
    }
  }
}

if (process.env.PLUGIN_CTX === "pro") {
  /* onlypro:start */

  /**
   * An item gets relocated, so update the table or grid view.
   */
  hooks.register("attachment/relocate", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, attachmentId, nextId, lastIdInView, next, e, ui) {
      var attachmentsBrowser;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              attachmentsBrowser = $(ui.item).parents(".attachments-browser").data("backboneView");
              ui.item.stop().fadeTo(100, 0.2);
              _context.prev = 2;
              _context.next = 5;
              return request({
                location: {
                  path: "/attachments/" + attachmentId,
                  method: "PUT"
                },
                request: {
                  folderId: node.id,
                  nextId: nextId,
                  lastId: lastIdInView
                }
              });

            case 5:
              node.setter(function (node) {
                return node.contentCustomOrder = 1;
              });
              applyToAttachmentsBrowser(attachmentsBrowser, node);
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              message.error(_context.t0.responseJSON.message);

            case 12:
              _context.prev = 12;
              ui.item.stop().fadeTo(100, 1);
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9, 12, 15]]);
    }));

    return function (_x, _x2, _x3, _x4, _x5, _x6, _x7) {
      return _ref.apply(this, arguments);
    };
  }());
  /**
   * Prepare sortable in list table mode.
   */

  hooks.register("ready", function () {
    var lastIdInView; // Grid mode

    $(document).on("sortstart", ".attachments-browser ul.attachments", function () {
      var _$$parents$data = $(this).parents(".attachments-browser").data("backboneView"),
          collection = _$$parents$data.collection;

      lastIdInView = collection.models[collection.models.length - 1].id;
    }).on("sortupdate", ".attachments-browser ul.attachments", function (e, ui) {
      var next = ui.item.next(),
          nextId = next.html() ? next.data("id") : false,
          attachmentId = ui.item.data("id"),
          folder = $(this).parents(".attachments-browser").data("backboneView").controller.$RmlAppTree.getTreeItemById();
      /**
       * (Pro only) An attachment is relocated and should be saved to the server.
       *
       * @event module:util/hooks#attachment/relocate
       * @param {module:store/TreeNode~TreeNode} folder The tree node
       * @param {int} attachmentId The attachment id
       * @param {int} nextId The next id
       * @param {int} lastIdInView
       * @param {jQuery} next
       * @this Sortable list
       */

      hooks.call("attachment/relocate", [folder, attachmentId, nextId, lastIdInView, next, e, ui], $(this));
    }); // List mode

    $(WP_TABLE_LIST_SELECTOR).sortable({
      disabled: true,
      appendTo: "body",
      tolerance: "pointer",
      scrollSensitivity: 50,
      placeholder: "ui-sortable-helper-wp-media-list",
      scrollSpeed: 50,
      distance: 10,
      cursor: "move",
      start: function start(e, ui) {
        ui.placeholder.height(ui.helper[0].scrollHeight); // The last ID (grid mode is done in the backbone collection)

        lastIdInView = +$(WP_TABLE_LIST_SELECTOR).find('tr:last > .check-column > input[type="checkbox"]').val();
      },
      update: function update(e, ui) {
        var next = ui.item.next(),
            nextId = next.html() ? next.find('> .check-column > input[type="checkbox"]').val() : false,
            attachmentId = ui.item.find('> .check-column > input[type="checkbox"]').val(),
            folderId = $(".rml-container .aiot-active").data("id");
        hooks.call("attachment/relocate", [store.getTreeItemById(folderId), attachmentId, nextId, lastIdInView, next, e, ui], $(this));
      }
    });
  });
  /* onlypro:end */
}
/**
 * Checks if a filter is active.
 *
 * @param {object} [attachmentsBrowser] If set the filter is searched in the backbone controller
 */


export function isFilterActive(attachmentsBrowser) {
  if (attachmentsBrowser) {
    var filters = ["monthnum", "year", "uploadedTo", "type"],
        props = attachmentsBrowser.collection.props;

    for (var i = 0; i < filters.length; i++) {
      if (props.get(filters[i])) {
        return true;
      }
    }

    return false;
  } else {
    // List
    return !!urlParam("attachment-filter");
  }
}
/**
 * Checks if a orderby is active.
 *
 * @param {object} [attachmentsBrowser] If set the filter is searched in the backbone controller
 */

export function isOrderByActive(attachmentsBrowser) {
  var orderby = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "rml";
  var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ASC";

  if (attachmentsBrowser) {
    var props = attachmentsBrowser.collection.props,
        propOrder = props.get("order") || "DESC";
    return props.get("orderby") === orderby && propOrder.toUpperCase() === order.toUpperCase();
  } else {
    // List
    var _propOrder = urlParam("order") || "DESC";

    return urlParam("orderby") === orderby && _propOrder.toUpperCase() === order.toUpperCase();
  }
}
/**
 * @returns {string}
 */

export function orderUrl() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  return addUrlParam(addUrlParam(href, "orderby", "rml"), "order", "asc");
}
/**
 * (Pro only) Toggle the sortable mode. Popup a message if custom order is not disabled, yet.
 * If custom order is enabled check the different list and grid mode behavior.
 *
 * @param {object} selected The selected node
 * @parma {boolean} mode The mode to activate
 * @param {object} [attachmentsBrowser] If set the filter is searched in the backbone controller
 */

export function toggleSortable(selected, mode, attachmentsBrowser) {
  if (process.env.PLUGIN_CTX === "lite") {
    return false;
  } else {
    /* onlypro:start */
    var orderByActive = isOrderByActive(attachmentsBrowser) || isOrderByActive(attachmentsBrowser, "date", "DESC"),
        filterActive = isFilterActive(attachmentsBrowser),
        redirect = !orderByActive || filterActive; // Redirect to the sortable mode

    if (redirect && mode) {
      if (!attachmentsBrowser) {
        var href = orderUrl();
        window.location.href = href + "#order";
      } else {
        // Grid mode, show popup that the filters should be deactivated
        message.error(i18n("orderFilterActive"));
      }

      return false;
    } // Toggle sortable


    (attachmentsBrowser ? attachmentsBrowser.attachments.$el : $(WP_TABLE_LIST_SELECTOR)).sortable(mode ? "enable" : "disable");
    return true;
    /* onlypro:end */
  }
}